<template>
  <b-card>
    <b-form @submit="onPreview">
      <p class="text-danger font-weight-bolder">Personal Information</p>
      <b-row>
        <!-- AM Name + NIK -->
        <b-col md="6">
          <b-form-group>
            <template #label>
              AM Name <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="form.am_name" id="am_name" placeholder="Ex. " required />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <template #label>
              NIK <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="form.nik" id="nik" placeholder="Ex. " required />
          </b-form-group>
        </b-col>

        <!-- Segment/Witel + Division/TREG -->
        <b-col md="6">
          <b-form-group>
            <template #label>
              Segment <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="form.witel" id="witel" placeholder="Ex. " required />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <template #label>
              Division/TREG <span class="text-danger">*</span>
            </template>
            <Select2
              v-model="form.division"
              :settings="select2SettingsDivision"
              id="division"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Phone Number + Email -->
        <b-col md="6">
          <b-form-group>
            <template #label>
              Phone Number <span class="text-danger">*</span>
            </template>
            <b-form-input type="tel" v-model="form.phone_number" id="phone_number" placeholder="Ex. " required />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <template #label>
              Email <span class="text-danger">*</span>
            </template>
            <b-form-input type="email" v-model="form.email" id="email" placeholder="Ex. " required />
          </b-form-group>
        </b-col>

        <!-- Project Name -->
        <b-col md="12">
          <p class="text-danger font-weight-bolder">Reservation Details</p>
          <b-form-group>
            <template #label>
              Project Name <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="form.project_name" id="project_name" placeholder="Ex. " required />
          </b-form-group>
        </b-col>

        <!-- Customer Name + Project Status -->
        <b-col md="6">
          <b-form-group>
            <template #label>
              Customer Name <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="form.customer_name" id="customer_name" placeholder="Ex. " required />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <template #label>
              Project Status <span class="text-danger">*</span>
            </template>
            <b-form-select v-model="form.project_status" id="project_status" :options="['F1', 'F2', 'F3', 'F4', 'F5']" required />
          </b-form-group>
        </b-col>

        <!-- Date + Time -->
        <b-col md="6">
          <b-form-group>
            <template #label>
              Date <span class="text-danger">*</span>
            </template>
            <!-- <b-form-datepicker v-model="form.date" id="date" class="w-100" :date-disabled-fn="isDateDisabled" :min="today" required /> -->
            <b-form-datepicker
              v-model="form.date"
              id="date"
              class="w-100"
              :date-disabled-fn="datePickerOptions.dateDisabledFn"
              :min="datePickerOptions.min"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <template #label>
              Time <span class="text-danger">*</span>
            </template>
            <b-form-select
              v-model="form.time"
              id="time"
              :options="timeOptions"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Product Category + Product Name -->
        <b-col md="6">
          <b-form-group>
            <template #label>
              Product Name <span class="text-danger">*</span>
            </template>
            <Select2
              :value="form.product_name"
              :settings="select2SettingsProduct"
              id="product_name"
              @select="onProductSelectedParent"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <template #label>
              Portfolio <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="form.product_category" id="product_category" placeholder="Ex. " required  disabled/>
          </b-form-group>
        </b-col>

        <b-col md="12" v-for="(item, index) in products" :key="index">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <template #label>Product Name II <span class="text-danger">*</span></template>
                <Select2
                  :value="item.product_name"
                  :settings="select2SettingsProduct"
                  :id="'product_name_' + index"
                  @select="selected => onProductSelectedChild(index, selected)"
                  required
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <template #label>Portfolio II <span class="text-danger">*</span></template>
                <b-form-input
                  v-model="item.product_category"
                  :id="'product_category_' + index"
                  disabled
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="12">
          <b-form-group>
            <b-button
              variant="outline-primary"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top="'Add Product'"
              @click="addProduct"
            >
              <feather-icon icon="PlusIcon" />
              Add Product
            </b-button>
  
            <b-button
              variant="outline-danger"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top="'Remove Last Product'"
              @click="removeLastProduct"
              :disabled="products.length === 0"
            >
              <feather-icon icon="TrashIcon" />
              Delete Product
            </b-button>
          </b-form-group>
        </b-col>

        <!-- Notes -->
        <b-col md="12">
          <b-form-group>
            <template #label>Notes <span class="text-danger">*</span></template>
            <b-form-textarea v-model="form.notes" id="notes" placeholder="Ex. " rows="3" required />
          </b-form-group>
        </b-col>

          <b-col class="d-flex justify-content-end">
          <b-button variant="primary" class="mr-2" @click="$router.go(-1)">
            Back
          </b-button>
          <b-button variant="primary" type="submit">Preview</b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-modal
      title="Preview Reservation Request"
      hide-footer
      id="preview-reservation"
      size="lg"
      centered
      hide-header-close
    >
      <b-form>
        <b-row>
          <!-- AM Name + NIK -->
          <b-col md="6">
            <b-form-group>
              <template #label>
                AM Name <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.am_name" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label>
                NIK <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.nik" disabled />
            </b-form-group>
          </b-col>

          <!-- Segment/Witel + Division/TREG -->
          <b-col md="6">
            <b-form-group>
              <template #label>
                Segment <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.witel" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label>
                Division/TREG <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.division" disabled />
            </b-form-group>
          </b-col>

          <!-- Phone Number + Email -->
          <b-col md="6">
            <b-form-group>
              <template #label>
                Phone Number <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.phone_number" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label>
                Email <span class="text-danger">*</span>
              </template>
              <b-form-input type="email" v-model="form.email" disabled />
            </b-form-group>
          </b-col>

          <!-- Project Name -->
          <b-col md="12">
            <b-form-group>
              <template #label>
                Project Name <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.project_name" disabled />
            </b-form-group>
          </b-col>

          <!-- Customer Name + Project Status -->
          <b-col md="6">
            <b-form-group>
              <template #label>
                Customer Name <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.customer_name" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label>
                Project Status <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.project_status" disabled />
            </b-form-group>
          </b-col>

          <!-- Date + Time -->
          <b-col md="6">
            <b-form-group>
              <template #label>
                Date <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.date" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label>
                Time <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.time" disabled />
            </b-form-group>
          </b-col>

          <!-- Product Category + Product Name -->
          <b-col md="6">
            <b-form-group>
              <template #label>
                Portfolio <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.product_category" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <template #label>
                Product Name <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="form.product_namex" disabled />
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="products.length > 0">
            <b-form-group>
              <template #label>
                Portfolio II
              </template>
              <b-form-input v-model="products[0].product_category" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="products.length > 0">
            <b-form-group>
              <template #label>
                Product Name II
              </template>
              <b-form-input v-model="products[0].product_name" disabled />
            </b-form-group>
          </b-col>

          <!-- Notes -->
          <b-col md="12">
            <b-form-group label="Notes">
              <b-form-textarea v-model="form.notes" rows="3" disabled />
            </b-form-group>
          </b-col>

          <!-- Submit Button -->
          <b-col class="d-flex justify-content-end">
            <b-button
              type="button"
              variant="light"
              class="mr-1"
              @click="$bvModal.hide('preview-reservation')"
            >
              Close
            </b-button>
            <b-button
              type="button"
              variant="primary"
              class="mr-1"
              @click="onSubmit"
              :disabled="isLoading"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BContainer, 
  BRow,
  BCol,
  BButton,
  BCard,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BImg,
  BFormTextarea,
  BCollapse,
  VBTooltip,
  VBToggle,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from "moment";
import Select2 from 'v-select2-component';
import { generateToken } from '@/auth/helperAuth'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    Select2,
    BRow,
    BCol,
    BButton,
    BCard,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    DatePicker,
    BImg,
    BFormTextarea,
    BCollapse,
    moment,
  },

  data() {
    return {
      token:"",
      isLoading: false,
      snowOption: {
        theme: 'snow',
      },
      dzInstance: null,
      form: {
        product_namex: '',
        am_name: '',
        nik: '',
        witel: '',
        division: '',
        phone_number: '',
        email: '',
        project_name: '',
        customer_name: '',
        project_status: '',
        date: null,
        time: '',
        product_category: '',
        product_name: null,
        notes: '',
      },
      times: [
        { value: '09.00 - 10.00 WIB', start: 9 },
        { value: '10.00 - 11.00 WIB', start: 10 },
        { value: '13.00 - 14.00 WIB', start: 13 },
        { value: '14.00 - 15.00 WIB', start: 14 },
        { value: '15.00 - 16.00 WIB', start: 15 },
      ],
      products: [],
      select2SettingsProduct: {
        placeholder: 'Cari produk...',
        allowClear: true,
        ajax: null,
      },
      select2SettingsDivision: {
        placeholder: 'Cari divisi...',
        allowClear: true,
        ajax: null,
      },
      usedDates: [],
      today: new Date().toISOString().split('T')[0],
      productNames: [],
      allowBackdateReservation: null,
    }
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {
    'form.product_category'(newVal) {
      this.form.product_name = null

      // Jika ingin trigger ulang AJAX (opsional tergantung plugin Select2 yang kamu pakai)
      if (this.$refs.productSelect2 && this.$refs.productSelect2.$el) {
        const select2El = $(this.$refs.productSelect2.$el).find('select');
        select2El.val(null).trigger('change'); // Reset Select2 visual
      }
    },
    'form.date'() {
      this.form.time = ''
    }
  },
  computed: {
    datePickerOptions() {
      this.$http.get(`/user/id/my`)
      .then(res => {
        console.log("res",res)
        let data = res.data.data.records
        this.allowBackdateReservation = data[0].ALLOW_BACKDATE_RESERVATION
      })
      if (this.allowBackdateReservation === 1) {
        return {
          dateDisabledFn: null,
          min: null
        }
      } else {
        return {
          dateDisabledFn: this.isDateDisabled,
          min: this.today
        }
      }
    },
    createdBy() {
      return this.$store.getters['oauth/getActiveUser'].id
    },
    timeOptions() {
      const now = new Date()
      const currentHour = now.getHours()

      return this.times.map(slot => {
        // default false
        let disabled = false

        // cek kalau tanggal dipilih = hari ini
        if (this.form.date) {
          const selectedDate = new Date(this.form.date)
          const today = new Date()

          // bandingkan tanggal tanpa jam
          if (
            selectedDate.getFullYear() === today.getFullYear() &&
            selectedDate.getMonth() === today.getMonth() &&
            selectedDate.getDate() === today.getDate()
          ) {
            if (slot.start <= currentHour) {
              disabled = true
            }
          }
        }

        return {
          value: slot.value,
          text:  slot.value,
          disabled
        }
      })
    }
  },
  methods: {
    fetchUsedDates() {
      // this.$http.get(`http://localhost:9999/consultativeSelling/dateTime`, {
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling/dateTime`, {
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
        .then((data) => {
          const response = data.data
          this.usedDates = [
            ...new Set(
              response
                .map(item => item.date)
                .filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date)) // hanya format valid
            )
          ];
        })
        .catch(error => {
          this.$notif('Error', `${error.data.message}`, 'error')
        })
    },
    isDateDisabled(ymd, date) {
      return this.usedDates.includes(ymd); // ymd dalam format YYYY-MM-DD
    },
    onPreview(event) {
      event.preventDefault()
      this.form.product_namex = this.form.product_name ? this.form.product_name : document.getElementById('product_name').value
      this.$bvModal.show('preview-reservation')
    },
    onSubmit(event) {
      event.preventDefault()
      this.isLoading = true

      const requestData = {
        am_name: this.form.am_name,
        nik: this.form.nik,
        segmen_witel: this.form.witel,
        division_treg: this.form.division,
        phone_number: this.form.phone_number,
        email: this.form.email,
        project_name: this.form.project_name,
        customer_name: this.form.customer_name,
        project_status: this.form.project_status,
        date: this.form.date,
        time: this.form.time,
        product_category: [],
        product_name: [],
        note: this.form.notes,
        createdby: this.createdBy,
      }
      requestData.product_name.push(this.form.product_name ? this.form.product_name : document.getElementById('product_name').value)
      requestData.product_category.push(this.form.product_category)
      if (this.products.length > 0) {
        for (const i of this.products) {
          if (i.product_name) {
            requestData.product_name.push(i.product_name)
            requestData.product_category.push(i.product_category)
          }
        }
      }
      
      // this.$http.post(`http://localhost:9999/consultativeSelling`, requestData, {
      this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/consultativeSelling`, requestData, {
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
        .then(() => {
          this.$router.push({ 
            name: 'consultative-selling-reservation-callback',
            params: { status: 'ok' }
          })
        })
        .catch(error => {
          this.$notif('Error', `${error.data.message}`, 'error')
        })
    },
    addProduct() {
      if(this.products.length === 0){
        this.products.push({ product_name: '', product_category: '' });
        this.$nextTick(() => {
          const arrows = document.querySelectorAll('.select2-selection__arrow');
          arrows.forEach((arrow) => {
            arrow.remove(); // Hapus setiap elemen
          });
        });
      }
    },
    removeLastProduct() {
      if (this.products.length > 0) {
        this.products.pop();
      }
    },
    onProductSelectedChild(index, selected) {
      this.products[index].product_name = selected.text;
      this.products[index].product_category = selected.category;
    },
    onProductSelectedParent(selected) {
      this.form.product_name = selected.text
      this.form.product_category = selected.category
    },
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
    this.select2SettingsProduct.ajax = {
      url: `${process.env.VUE_APP_API_HELPER_URL}/product/list`,
      dataType: 'json',
      delay: 250,
      headers: {
        'Client-Device': 'browser',
        Authorization: this.token,
      },
      data: (params) => {
        return {
          status: 'publish',
          retired: false,
          page: params.page || 1,
          perPage: 10,
          product: params.term || '',
        }
      },
      processResults: (data) => {
        return {
          results: data.data.map((item) => ({
            id: item.product,
            text: item.product,
            category: item.category.name,
          })),
          pagination: {
            more: data.data.length === 10,
          },
        }
      },
      cache: true,
    }

    this.select2SettingsDivision.ajax = {
      url: `${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`,
      dataType: 'json',
      delay: 250,
      headers: {
        'Client-Device': 'browser',
        Authorization: this.token,
      },
      data: (params) => {
        return {
          table: 'cfu_unit_division',
          search: params.term || '',
          page: params.page || 1,
          perPage: 10,
        };
      },
      processResults: (data) => {
        return {
          results: data.data.map((item) => ({
            id: item.unit,
            text: item.unit,
          })),
          pagination: {
            more: data.data.length === 10,
          },
        };
      },
      cache: true,
    };
  },
  mounted() {
    this.fetchUsedDates();
    this.$nextTick(() => {
      const arrows = document.querySelectorAll('.select2-selection__arrow');
      arrows.forEach((arrow) => {
        arrow.remove(); // Hapus setiap elemen
      });
    });
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>

<style scoped>


</style>
